import React, {useState} from "react";
import Button from "../Button";
import {DownloadIcon} from "@heroicons/react/solid";
import FileSaver from "file-saver";

// Types ----

export type ExportButtonProps = {
  getData: () => Promise<Blob>
  dataType: string
  prefix: string
  extension: string
}

// Component ----

export default function ExportButton({getData, dataType, prefix, extension}: ExportButtonProps) {
  const [isExporting, setIsExporting] = useState<boolean>(false);

  async function exportData() {
    setIsExporting(true);

    const exportTime = new Date();

    const data = await getData();
    const blob = new Blob([data], {type: dataType});

    setIsExporting(false);

    FileSaver.saveAs(blob, `${prefix}-${exportTime.getTime()}.${extension}`)
  }

  return (
    <Button
      color={Button.colors.PRIMARY}
      icon={DownloadIcon}
      onClick={exportData}
      showSpinner={isExporting}
      disabled={isExporting}
    >
      Export
    </Button>
  )
}